import { defineComponent as r, computed as l, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const v = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "5c134ff1-94ec-4d83-aca7-71ee5b1bec61" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#5c134ff1-94ec-4d83-aca7-71ee5b1bec61)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#acabb1" d="m401 156-34 11-33-11-11-28 11-28h67l-11 28Z"></path><path fill="#338af3" d="M289 156v122c0 60 78 78 78 78s78-18 78-78V156H289z"></path><path fill="#6da544" d="M296 307c20 37 71 49 71 49s52-12 71-49l-71-118-71 118z"></path><path fill="#ffda44" d="m445 277-78-121-78 121v1a62 62 0 0 0 7 29l71-110 71 110a62 62 0 0 0 7-29z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path>', 7), g = { fill: "none" }, V = ["r"], y = /* @__PURE__ */ r({
  __name: "pn",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, a = l(() => 512 + 2 * e.strokeWidth), o = l(() => -e.strokeWidth), h = l(() => 256 + e.strokeWidth / 2);
    return (x, b) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${a.value} ${a.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (c(), s("title", k, d(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: h.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, v));
  }
});
export {
  y as default
};
//# sourceMappingURL=pn-eaa42e94.js.map
